import { render, staticRenderFns } from "./jean-stodden.vue?vue&type=template&id=038b0462&scoped=true"
import script from "./jean-stodden.vue?vue&type=script&lang=js"
export * from "./jean-stodden.vue?vue&type=script&lang=js"
import style0 from "./jean-stodden.vue?vue&type=style&index=0&id=038b0462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b0462",
  null
  
)

export default component.exports